export default __webpack_public_path__ + "src/assets/tasks/horerduordet/HDO_intro4.mp3";